<template>
  <div class="moreNews" @touchmove.self.prevent @click.self="closePreview">
    <div class="moreNews-contentbox">
      <div class="moreNews-content-head">
        <span>消息列表</span>
      </div>
      <div class="moreNews-content-main">
        <div class="news-item" v-for="item in showData" @click="toArticle(item.url)">
          <div class="triangle_border_right"></div>
          <span>{{item.title}}</span>
        </div>
      </div>
      <img class="icon-close" src="../../assets/img/index/news-close.svg" alt="" @click="closePreview">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'MoreNews',
    props: ["showData"],
    mounted () {

    },
    data () {
      return {

      }
    },
    methods: {
      closePreview (){
        this.$emit('hideMoreNews')
      },
      toArticle (url){
        url ? window.location.href = url : ''
      }
    }
  }
</script>

<style lang="css" scoped>
  .moreNews{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    z-index: 9;
  }
  .moreNews-contentbox{
    width: 300px;
    height: 440px;
    margin: 50px auto;
    background-color: #F8F9FB;
    font-size: 13px;
    color: #333;
    position: relative;
  }
  .moreNews-content-head{
    height: 42px;
    background-color: rgb(255,120,0);
    border: none;
    border-bottom-right-radius: 150px 18px;
    border-bottom-left-radius: 150px 18px;
    text-align: center;
    font-size: 16px;
    color: #fff;
    line-height: 42px;
  }
  .moreNews-content-main{
    overflow-y: auto;
    padding: 10px 5px 20px 10px;
    height: 366px;
  }
  .news-item{
    line-height: 18px;
    margin-top: 10px;
    background-color: #fff;
    padding: 10px;
  }
  .news-item span{
    width: 255px;
    display: inline-block;
  }
  /*.triangle_border_right{*/
    /*width:0;*/
    /*height:0;*/
    /*border-width:4px 0 4px 4px;*/
    /*border-style:solid;*/
    /*border-color:transparent transparent transparent #ccc;!*透明 透明 透明 灰*!*/
    /*!*margin:40px auto;*!*/
    /*position:relative;*/
    /*display: inline-block;*/
    /*vertical-align: top;*/
    /*margin-top: 5px;*/
    /*margin-right: 5px;*/
  /*}*/
  .triangle_border_right span{
    display:block;
    width:0;
    height:0;
    border-width:3px 0 3px 3px;
    border-style:solid;
    border-color:transparent transparent transparent #ccc;/*透明 透明 透明 黄*/
    position:absolute;
    top:-2px;
    left:-3px;
  }
  .triangle_border_right{
    background-color: rgb(255,120,0);
    width: 4px;
    height: 4px;
    display: inline-block;
    border-radius: 50%;
    margin-right: 2px;
    vertical-align: top;
    margin-top: 7px;
  }
  .icon-close{
    position: absolute;
    width: 30px;
    bottom: -50px;
    left: 135px;
  }
</style>



// WEBPACK FOOTER //
// moreNews.vue?77b84be1